module.exports = ":host {\n  width: 100%;\n  height: auto;\n  min-height: 100vh;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-top: 64px; }\n  @media (min-width: 600px) {\n    :host {\n      padding-top: 84px; } }\n  @media (min-width: 960px) {\n    :host {\n      padding-top: 0;\n      height: 100%;\n      min-height: 0; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page/page.component.scss
// module id = ./src/app/page/page.component.scss
// module chunks = main